import { connect } from "react-redux"

import NavBar from "./NavBar"

import { itemSelected } from "../../actions/navbar-actions"

const mapStateToProps = ({ navbar, router: { location } }) => ({
    navbarItems: navbar,
    activeLocation: location && location.pathname ? location.pathname : ""
})

const mapDispatchToProps = dispatch => ({
    onNavItemClick: (routeIndex, path) =>
        dispatch(itemSelected(routeIndex, path))
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)
